import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useFirestore } from "reactfire";
import MentorRequestCard from "./components/mentor-profile-card/MentorProfileCard";
import SelectCountry from "../../../../../shared/components/countrySelectorModal/SelectCountry";
import { useAppUser } from "../../../../../contexts/user-context/UserContext";
import MentorProfileCreateHeader from "../mentor-profile-create/MentorProfileCreateHeader";
import { MCountry } from "../mentoring-session-requests/MentoringSessionRequests";
import { Country } from "../../../../../shared/constants/Constant";
import firebase from "firebase/app";

export interface Mentor {
  id: string;
  photoURL: string;
  fullName: string;
  bio: string;
  qualification: string;
  designation: string;
  createdAt: Date;
  countries: Country[];
}

const MentorProfiles = () => {
  const store = useFirestore();
  const appUser = useAppUser();

  const [country, setCountry] = useState<MCountry>(MCountry.COUNTRY);
  const [fMentors, setFMentors] = useState<Mentor[]>([]);
  const [mentors, setMentors] = useState<Mentor[]>([]);
  const [modalCountrySelectorShow, setModalCountrySelectorShow] = useState(
    false
  );

  useEffect(() => {
    setFMentors([]);
    setFMentors((ps) => {
      if (country === MCountry.ALL || country === MCountry.COUNTRY) {
        return mentors.sort(
          (a: Mentor, b: Mentor) =>
            b.createdAt.getTime() - a.createdAt.getTime()
        );
      } else {
        return mentors
          .sort(
            (a: Mentor, b: Mentor) =>
              b.createdAt.getTime() - a.createdAt.getTime()
          )
          .filter((m) => m.countries.includes(country as any));
      }
    });
  }, [mentors, country]);

  useEffect(() => {
    setMentors([]);
    if (
      appUser.userRole.isModerator ||
      (!appUser.userRole.isModerator && appUser.userRole.isMember)
    ) {
      let query:
        | firebase.firestore.Query
        | firebase.firestore.CollectionReference = store.collection("mentors");

      if (!appUser.userRole.isAdmin && appUser.userRole.isMember) {
        query = query.where("countries", "array-contains", appUser.country);
      }

      return query.onSnapshot({}, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            setMentors((ps) => {
              ps.push({
                ...(change.doc.data() as any),
                createdAt: new Date(change.doc.data().createdAt.seconds * 1000),
                id: change.doc.id,
              });
              return Object.assign([], ps);
            });
          }
          if (change.type === "modified") {
            setMentors((ps) => {
              const modified = ps.map((a) => {
                if (a.id === change.doc.id) {
                  return {
                    ...(change.doc.data() as any),
                    createdAt: new Date(
                      change.doc.data().createdAt.seconds * 1000
                    ),
                    id: change.doc.id,
                  };
                } else {
                  return a;
                }
              });
              return Object.assign([], modified);
            });
          }
          if (change.type === "removed") {
            setMentors((ps) => {
              const removed = ps.filter((a) => a.id !== change.doc.id);
              return Object.assign([], removed);
            });
          }
        });
      });
    }
  }, [store, appUser.userRole, appUser.country]);

  return (
    <div>
      <MentorProfileCreateHeader showButton title="Mentor Profiles" />
      <Container
        fluid
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
        }}
      >
        <Row className="mb-5" style={{ justifyContent: "flex-end" }}>
          {appUser.userRole.isAdmin && (
            <Col
              xs={12}
              md={3}
              xl={3}
              className="d-flex align-items-center my-1 my-md-0"
            >
              <div style={{ flex: "1" }}>
                <select
                  className="app-input input-small filter-img"
                  value={country}
                  onChange={(e) => {
                    setCountry(e.target.value as any);
                  }}
                >
                  <option value={MCountry.COUNTRY} disabled hidden>
                    Select Country
                  </option>
                  <option value={MCountry.ALL}>All Countries</option>
                  <option value={MCountry.BOSNIA}>Bosnia</option>
                  <option value={MCountry.INDIA}>India</option>
                  <option value={MCountry.JAMAICA}>Jamaica</option>
                  <option value={MCountry.MALAYSIA}>Malaysia</option>
                  <option value={MCountry.SRI_LANKA}>Sri Lanka</option>
                  <option value={MCountry.INDONESIA}>Indonesia</option>
                </select>
              </div>
            </Col>
          )}
        </Row>
        <Row className="">
          {fMentors.map((mentor, index) => (
            <MentorRequestCard
              key={index}
              bio={mentor.bio}
              id={mentor.id}
              onRequest={(id) => {}}
              title={mentor.fullName}
              photoURL={mentor.photoURL}
              designation={mentor.designation}
              qualification={mentor.qualification}
            />
          ))}
        </Row>
      </Container>
      {appUser.userRole.isAdmin && (
        <SelectCountry
          show={modalCountrySelectorShow}
          onHide={() => {
            setModalCountrySelectorShow(false);
          }}
        />
      )}
    </div>
  );
};

export default MentorProfiles;
